import React from 'react';
import PropTypes from 'prop-types';

import '../stages/Footer.css'
import Button from './Button'

export default function Document({ text, image, buttonText, urlLink = '' }) {

    return (
        <div className='document-card vertical-content'>
            <img className='document-image' src={`imgs/footer/documents/${ image }.png`} alt={ image }/>
            <div className='horizontal-content top-content document-text'>
                <div className='text-small'> { text } </div>
            </div>
            <div className='document-button'>
                <Button className='btn btn-primary btn-sm' text={ buttonText } urlLink={ urlLink }></Button>
            </div>
        </div>
    )
}

Document.propTypes = {
    text: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    urlLink: PropTypes.string
};
